import React from 'react';
import { Page, Text, View, Document, Font } from '@react-pdf/renderer';
import Image from '../../common/PDF/Image';
import styles from '../../common/PDF/LayoutStylesheet';
import Table from '../../common/PDF/Table';
import OverviewPDF from '../../common/PDF/Overview';
import DateRange from '../../common/PDF/DateRange';
import PDFHeader from './PDFHeader';
import { convertToThousands, addPercent, splitByThousands } from '../../../helpers/NumberFormatter';

const renderViews=(data)=>{
  const columns=[
	 {key: 'stream_date', title: 'Stream Date', width: 40, fontSize: 5},
	 {key: 'total', title: 'Total', width: 15, formatFn: convertToThousands, fontSize: 5},
	 {key: 'engaged', title: 'Engaged', width: 15, formatFn: splitByThousands, fontSize: 5},
	 {key: 'free', title: 'Free', width: 15, formatFn: convertToThousands, fontSize: 5},
	 {key: 'premium', title: 'Premium', width: 15, formatFn: splitByThousands, fontSize: 5},
 ];
	 
  return <Table
	  columns={columns}
	  items={data}
  />
}

const renderTracks=(data)=>{
  const columns=[
	 {key: 'track_title', title: 'Titme', width: 25, fontSize: 5},
	 {key: 'isrc', title: 'ISRC', width: 15, fontSize: 5},
	 {key: 'total', title: 'Total', width: 15, formatFn: convertToThousands, fontSize: 5},
	 {key: 'engaged', title: 'Engaged', width: 15, formatFn: splitByThousands, fontSize: 5},
	 {key: 'free', title: 'Free', width: 15, formatFn: convertToThousands, fontSize: 5},
	 {key: 'premium', title: 'Premium', width: 15, formatFn: splitByThousands, fontSize: 5},
 ];
	 
  return <Table
	  columns={columns}
	  items={data}
  />
}

const renderSources=(data)=>{
  const columns=[
	 {key: 'source', title: 'Source', width: 40, fontSize: 5},
	 {key: 'total', title: 'Total', width: 15, formatFn: convertToThousands, fontSize: 5},
	 {key: 'engaged', title: 'Engaged', width: 15, formatFn: splitByThousands, fontSize: 5},
	 {key: 'free', title: 'Free', width: 15, formatFn: convertToThousands, fontSize: 5},
	 {key: 'premium', title: 'Premium', width: 15, formatFn: splitByThousands, fontSize: 5},
 ];
	 
  return <Table
	  columns={columns}
	  items={data}
  />
}

const renderTerritories=(data)=>{
  const columns=[
	 {key: 'territory', title: 'Code', width: 10, fontSize: 5},
	 {key: 'name', title: 'Territory', width: 75, fontSize: 5},	 
	 {key: 'total', title: 'Total', width: 15, formatFn: splitByThousands, fontSize: 5},
 ];
	 
  return <Table
	  columns={columns}
	  items={data}
  />
}



export default (props) => {
	const { data: { images, tables, metadata, overview, reportTitle, globalFilter, entity, header }, widgetProps: { widgetState } } = props;
  return <Document>
	<Page size="A4" style={styles.page}>
	  <PDFHeader header={header} />
	  <View style={styles.section}>
		  <OverviewPDF data={header.overview} />
	  </View>
	  <View style={styles.section}>
			<View style={styles.column}>
			  <Text style={styles.smallHeader}>YouTube Views</Text>
			  {widgetState.youtube_views.mode == 'table' && renderViews(tables.youtube_views)}
			  {widgetState.youtube_views.mode != 'table' && <Image source={images.youtube_timeseries_chart} /> }
			</View>
	  </View>
	  </Page>
	  <Page size="A4" style={styles.page}>
		<View style={styles.section}>
		  <View style={styles.column}>
			<Text style={styles.smallHeader}>YouTube Tracks</Text>
			{widgetState.youtube_tracks.mode == 'table' && renderTracks(tables.youtube_tracks)}
			{widgetState.youtube_tracks.mode != 'table' && <Image source={images.youtube_tracks_chart} /> }
		  </View>
		</View>           
		<View style={styles.section}>
		  <View style={styles.column}>
			<Text style={styles.smallHeader}>YouTube Sources</Text>
			{widgetState.youtube_sources.mode == 'table' && renderSources(tables.youtube_sources)}
			{widgetState.youtube_sources.mode != 'table' && <Image source={images.youtube_sources_chart} /> }
		  </View>
		</View>           
	  </Page>
	  <Page size="A4" style={styles.page}>
	  <View style={styles.section}>
		<View style={styles.column}>
		  <Text style={styles.smallHeader}>YouTube Territories</Text>
		  {renderTerritories(tables.youtube_territories)}
		</View>
	  </View>           
	  </Page>
  </Document>
};